import React from "react";
import marketingIcon from "../../assets/Marketing.svg";
import utilityIcon from "../../assets/utility.svg";
import authenticationIcon from "../../assets/authentication.svg";
import {
  CATEGORIES,
  TEMPLATE_SUBTYPES,
  TC_RADIUS,
} from "../../constants/templateCreatorConstants";

const CATEGORY_TAB_ICONS = {
  MARKETING: marketingIcon,
  UTILITY: utilityIcon,
  AUTHENTICATION: authenticationIcon,
};

const SetupTemplateForm = ({
  category,
  subtype,
  onCategoryChange,
  onSubtypeChange,
}) => {
  const subtypes = TEMPLATE_SUBTYPES[category] || [];

  return (
    <div className={`border border-[#ccd0d5] ${TC_RADIUS} bg-white`}>
      <div className="px-3.5 pt-3 pb-0">
        <h2 className="text-[15px] font-semibold text-[#050505] mb-1">
          Set up your template
        </h2>
        <p className="text-[13px] text-[#65676b] mb-3 leading-relaxed">
          Choose the category that best describes your message template. Then,
          select the type of message that you want to send.{" "}
          <a
            href="https://developers.facebook.com/docs/whatsapp/business-management-api/message-templates"
            target="_blank"
            rel="noopener noreferrer"
            className="text-[#16A34A] hover:underline"
          >
            Learn more about categories.
          </a>
        </p>
      </div>

      <div className="px-3.5">
        <div
          className={`grid grid-cols-3 border border-[#ccd0d5] ${TC_RADIUS} overflow-hidden`}
        >
          {CATEGORIES.map(({ value, label }, index) => {
            const iconSrc = CATEGORY_TAB_ICONS[value];
            const active = category === value;
            return (
              <button
                key={value}
                type="button"
                onClick={() => onCategoryChange(value)}
                className={`flex items-center justify-center gap-2 py-2 px-2 text-[13px] font-semibold transition-colors ${
                  index < CATEGORIES.length - 1 ? "border-r border-[#ccd0d5]" : ""
                } ${
                  active
                    ? "bg-[#F0FDF4] text-[#16A34A]"
                    : "bg-white text-[#65676b] hover:bg-[#F8FDF9]"
                }`}
              >
                {iconSrc && (
                  <img src={iconSrc} alt="" className="w-4 h-4 shrink-0" />
                )}
                {label}
              </button>
            );
          })}
        </div>
      </div>

      <div className="p-3.5 pt-2.5">
        <div className={`border border-[#ccd0d5] ${TC_RADIUS} overflow-hidden`}>
          {subtypes.map((item, index) => {
            const selected = subtype === item.value;
            const disabled = item.enabled === false;
            return (
              <label
                key={item.value}
                className={`flex items-start gap-2.5 px-3 py-2 cursor-pointer transition-colors ${
                  index > 0 ? "border-t border-[#dddfe2]" : ""
                } ${
                  disabled
                    ? "cursor-not-allowed bg-white"
                    : selected
                      ? "bg-[#F0FDF4]"
                      : "bg-white hover:bg-[#F8FDF9]"
                }`}
              >
                <input
                  type="radio"
                  name="subtype"
                  value={item.value}
                  checked={selected}
                  disabled={disabled}
                  onChange={() => !disabled && onSubtypeChange(item.value)}
                  className="mt-1 w-4 h-4 accent-[#22C55E] shrink-0"
                />
                <div className="min-w-0 flex-1">
                  <p className={`text-[13.5px] font-semibold ${disabled ? "text-[#8A8D91]" : "text-[#050505]"}`}>
                    {item.label}
                  </p>
                  {item.description && (
                    <p className={`text-[12.5px] mt-0.5 leading-snug ${disabled ? "text-[#8A8D91]" : "text-[#65676B]"}`}>
                      {item.description}
                    </p>
                  )}
                </div>
              </label>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default SetupTemplateForm;
